var _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _rect, _rect2, _polygon3, _rect3, _rect4, _polygon4, _path8, _polygon5, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDevNoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 876.97244,
    height: 744,
    viewBox: "0 0 876.97244 744",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M676.51378,269h-26a5.00573,5.00573,0,0,1-5-5V238a5.00573,5.00573,0,0,1,5-5h26a5.00573,5.00573,0,0,1,5,5v26A5.00573,5.00573,0,0,1,676.51378,269Zm-26-34a3.00328,3.00328,0,0,0-3,3v26a3.00328,3.00328,0,0,0,3,3h26a3.00328,3.00328,0,0,0,3-3V238a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-161.51378 -78)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373.51378,114h-26a5.00573,5.00573,0,0,1-5-5V83a5.00573,5.00573,0,0,1,5-5h26a5.00573,5.00573,0,0,1,5,5v26A5.00573,5.00573,0,0,1,373.51378,114Zm-26-34a3.00328,3.00328,0,0,0-3,3v26a3.00328,3.00328,0,0,0,3,3h26a3.00328,3.00328,0,0,0,3-3V83a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-161.51378 -78)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M660.51378,256h-26a5.00573,5.00573,0,0,1-5-5V225a5.00573,5.00573,0,0,1,5-5h26a5.00573,5.00573,0,0,1,5,5v26A5.00573,5.00573,0,0,1,660.51378,256Zm-26-34a3.00328,3.00328,0,0,0-3,3v26a3.00328,3.00328,0,0,0,3,3h26a3.00328,3.00328,0,0,0,3-3V225a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-161.51378 -78)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.51378,473h-26a5.00573,5.00573,0,0,1-5-5V442a5.00573,5.00573,0,0,1,5-5h26a5.00573,5.00573,0,0,1,5,5v26A5.00573,5.00573,0,0,1,208.51378,473Zm-26-34a3.00328,3.00328,0,0,0-3,3v26a3.00328,3.00328,0,0,0,3,3h26a3.00328,3.00328,0,0,0,3-3V442a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-161.51378 -78)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.51378,460h-26a5.00573,5.00573,0,0,1-5-5V429a5.00573,5.00573,0,0,1,5-5h26a5.00573,5.00573,0,0,1,5,5v26A5.00573,5.00573,0,0,1,192.51378,460Zm-26-34a3.00328,3.00328,0,0,0-3,3v26a3.00328,3.00328,0,0,0,3,3h26a3.00328,3.00328,0,0,0,3-3V429a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-161.51378 -78)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.94313,164.03859H494.55862a51.15008,51.15008,0,0,1,49.89777,39.90062L666.03464,743.20648a41.34046,41.34046,0,0,1-38.29383,50.38232L380.38648,805.77594A54.61491,54.61491,0,0,1,323.956,760.94848l-68.96659-381.268-5.13082,1.466-13.19613-72.26456,5.28146-1.32037L222.69293,201.136a31.49278,31.49278,0,0,1,31.2502-37.09738Z",
    transform: "translate(-161.51378 -78)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M462.882,175.66378h28.08707a35.34863,35.34863,0,0,1,34.53616,27.81348L642.20364,738.34478a21.90324,21.90324,0,0,1-19.9674,26.52539l-246.55417,16.159a28.36684,28.36684,0,0,1-29.77274-23.27746L246.32983,204.914a24.84579,24.84579,0,0,1,24.45228-29.25017h26.645a11.72585,11.72585,0,0,1,11.32267,8.67742h0a10.35184,10.35184,0,0,0,9.99591,7.66063H445.23883a17.69522,17.69522,0,0,0,17.6431-16.33806Z",
    transform: "translate(-161.51378 -78)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "104 188.606 371.476 188.606 399.971 317 129 322 104 188.606",
    fill: "#ff8600"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "358 431.754 420.971 431.754 422.971 443.809 360 443.809 358 431.754",
    fill: "#ff8600"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 303.6674,
    y: 451.08379,
    width: 267.12453,
    height: 1.25708,
    transform: "translate(-170.9793 -68.64185) rotate(-1.21314)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 306.80298,
    y: 488.47287,
    width: 272.16437,
    height: 1.25714,
    transform: "translate(-172.68833 -67.64407) rotate(-1.32299)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "384 560.754 446.971 560.754 448.971 572.809 386 572.809 384 560.754",
    fill: "#ff8600"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 329.6674,
    y: 580.08379,
    width: 267.12453,
    height: 1.25708,
    transform: "translate(-173.70462 -68.06247) rotate(-1.21314)",
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 332.80298,
    y: 617.47287,
    width: 272.16437,
    height: 1.25714,
    transform: "translate(-175.65981 -67.00938) rotate(-1.32299)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "615.56 731.207 603.645 731.206 597.977 685.249 615.562 685.25 615.56 731.207",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M780.11212,820.75659l-38.41869-.00142v-.48593a14.95444,14.95444,0,0,1,14.95363-14.95339h.00095l23.46482.00095Z",
    transform: "translate(-161.51378 -78)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "763.576 723.405 751.979 726.136 735.926 682.702 753.043 678.671 763.576 723.405",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M930.69546,811.95075l-37.39588,8.80584-.1114-.473a14.95441,14.95441,0,0,1,11.12743-17.98318l.00093-.00022,22.84015-5.37823Z",
    transform: "translate(-161.51378 -78)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M774.639,615.36636c.02257-2.39517.732-58.91549,16.2249-80.28637l.22915-.31528,53.992,7.44866-1.20743,11.86268c2.37482,2.31,21.055,21.82982,26.44916,68.05373l57.30791,153.91483-26.64209,2.42186L822.12727,610.44889,780.39208,793.0841H753.98074Z",
    transform: "translate(-161.51378 -78)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M784.53881,537.165l5.27788-27.70841c-1.033-1.3298-5.611-7.71691-4.592-15.20371.66458-4.88441,3.58036-9.16748,8.66786-12.73353l13.68-31.92029.18434-.10806c.92139-.54286,22.70259-13.13782,34.577-1.2548.29685.23011,29.53339,23.43805,17.79275,54.74556L845.633,546.4672Z",
    transform: "translate(-161.51378 -78)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M766.17651,574.652a9.79821,9.79821,0,0,0,8.27541-12.53988l28.25071-20.35415-16.91194-6.4327-24.23457,20.31485a9.85129,9.85129,0,0,0,4.62039,19.01188Z",
    transform: "translate(-161.51378 -78)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M771.36857,541.72518l43.13015-33.9811-12.82221-43.80839a15.73981,15.73981,0,0,1,1.58883-12.45766,14.55826,14.55826,0,0,1,9.54634-6.89055c7.3835-1.56245,14.08622,2.57188,19.91712,12.28984l.0445.08772c.96461,2.3583,23.4336,57.901,6.27714,69.77891-16.78269,11.61859-55.69936,28.53222-56.09061,28.70258l-.45641.19706Z",
    transform: "translate(-161.51378 -78)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 667.17682,
    cy: 332.5559,
    r: 26.12766,
    fill: "#a0616a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 708.13866,
    cy: 300.11435,
    r: 23.11435,
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M889.58978,397.25451a23.11558,23.11558,0,0,1-35.69469-12.137,23.11562,23.11562,0,1,0,45.08988-9.479A23.1071,23.1071,0,0,1,889.58978,397.25451Z",
    transform: "translate(-161.51378 -78)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M798.37034,397.2802c4.03517-7.22412,5.57918-10.24183,10.78206-14.63472,4.6009-3.88507,10.26018-5.026,14.82486-1.34482a27.33647,27.33647,0,1,1-16.4941,25.09235,27.56231,27.56231,0,0,1,.18625-3.091C803.70162,402.7448,802.33813,397.83743,798.37034,397.2802Z",
    transform: "translate(-161.51378 -78)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.48622,822h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-161.51378 -78)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDevNoBg);
export default __webpack_public_path__ + "static/media/cloudDevNoBg.75b784da521dbba7f75f030e88b227ae.svg";
export { ForwardRef as ReactComponent };